var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"box"},[_c('bar-content',{ref:"barContent",on:{"setDirectAndSpareModal":_vm.setDirectAndSpareModal}})],1),_c('set-direct-and-spare-modal',{ref:"setDirectAndSpareModal"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }